/**
 * Utility functions for Urdu font detection and styling
 */

/**
 * Detects if a string contains Urdu/Arabic characters
 * @param {string} text - The text to check
 * @returns {boolean} - True if text contains Urdu/Arabic characters
 */
export const isUrduText = (text) => {
  if (!text || typeof text !== 'string') return false;
  
  // Unicode ranges for Arabic, Persian, and Urdu
  // Arabic: U+0600–U+06FF
  // Arabic Supplement: U+0750–U+077F
  // Arabic Extended-A: U+08A0–U+08FF
  // Arabic Presentation Forms-A: U+FB50–U+FDFF
  // Arabic Presentation Forms-B: U+FE70–U+FEFF
  const urduArabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  
  return urduArabicRegex.test(text);
};

/**
 * Gets the appropriate className for text based on whether it contains Urdu
 * @param {string} text - The text to check
 * @returns {string} - 'urdu' if Urdu detected, empty string otherwise
 */
export const getUrduClassName = (text) => {
  return isUrduText(text) ? 'urdu' : '';
};

/**
 * Gets sx props for Material-UI components based on Urdu detection
 * @param {string} text - The text to check
 * @returns {object} - sx props object if Urdu detected, empty object otherwise
 */
export const getUrduSxProps = (text) => {
  if (!isUrduText(text)) return {};

  return {
    fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', serif",
    fontSize: '1.0625rem',
    lineHeight: 1.6,
    direction: 'rtl',
    textAlign: 'right'
  };
};

